module.exports = __webpack_public_path__ + "media/new-order.53ecaf45.mp3";